// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"483":"b6f7f219","544":"d4139ab1","791":"b6f7f219"}[chunkId] + ".chunk.css";
};